import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-modal": "true",
  ref: "new-folder-dialog-content-ref",
  class: "wrapper"
}
const _hoisted_2 = {
  role: "Title input",
  class: "input-wrapper"
}
const _hoisted_3 = {
  class: "p-input-icon-right",
  "aria-label": "Title input"
}
const _hoisted_4 = ["src", "tabindex"]
const _hoisted_5 = { class: "char-count" }
const _hoisted_6 = {
  class: "buttons",
  style: {"flex-direction":"row"}
}
const _hoisted_7 = ["disabled"]

import { ref, onUpdated } from "vue";
import CloseCircle from "../assets/images/CloseCircle.svg";
import { limitCharacter } from "../assets/helpers";
import ErrorBanner from './Modals/ErrorBanner.vue';
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'FolderModal',
  props: {
    visible: { type: Boolean },
    setVisible: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const newFolder = ref(""),
      errorBannerMessage = ref(""),
      showErrorBanner = ref(false),
      loading = ref(false),
      store = useStore();

function filterKey(event: KeyboardEvent) {
    limitCharacter(event, (event.target as HTMLInputElement).value);
}

function close() {
    setshowErrorBanner(false);
    errorBannerMessage.value = "";
    newFolder.value = "";
    loading.value = false;
    props.setVisible(false);
}

function setshowErrorBanner(visible: boolean) {
    showErrorBanner.value = visible;
}

function handleCloseKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
        event.preventDefault();
        (event.target as HTMLElement).blur();
        close();
    }
}

async function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
        event.preventDefault();
        await handleCreateFolder();
        (event.target as HTMLElement).blur();
        close();
    }
}

function handleClearKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
        event.preventDefault();
        const input = (event.target as HTMLElement).previousElementSibling as HTMLInputElement;
        newFolder.value = "";
        (event.target as HTMLElement).blur();
        input.focus();
    }
}

async function handleCreateFolder() {
    try {
        if (newFolder.value === "" ) {
            props.setVisible(false);
            return;
        }
        loading.value = true;
        const payload = {
            title: newFolder.value.trim(),
            type: "folder",
        };
        await store.dispatch("itemList/createItem", payload)
        close();
    } catch (error:any) {
        if (error.message.includes("F_NAME_UNIQUE")) {
            errorBannerMessage.value = "Folder title must be unique";
        } else {
            errorBannerMessage.value = "Oops! Something went wrong. Please try again later.";
        }
        setshowErrorBanner(true);
    } finally {
        loading.value = false;
    }
}

// Reset input on dialog update
onUpdated(() => {
    newFolder.value = "";
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    class: "create-folder-dialog",
    modal: true,
    "close-on-escape": true,
    "aria-expanded": props.visible,
    "aria-describedby": "Create folder modal",
    "dismissable-mask": true,
    closable: false
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "title" }, "Create new folder", -1)),
        _createVNode(ErrorBanner, {
          message: errorBannerMessage.value,
          visible: showErrorBanner.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (setshowErrorBanner(false)))
        }, null, 8, ["message", "visible"]),
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              autofocus: "",
              id: "newFolder",
              modelValue: newFolder.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newFolder).value = $event)),
              class: "input",
              onKeydown: filterKey,
              tabindex: "0"
            }, null, 8, ["modelValue"]),
            (newFolder.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onKeydown: handleClearKey,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (newFolder.value = '')),
                  src: _unref(CloseCircle),
                  alt: "Clear input",
                  "aria-label": "Clear input",
                  "aria-roledescription": "button",
                  tabindex: newFolder.value.length > 0 ? 0 : -1,
                  class: "clear-icon"
                }, null, 40, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(newFolder.value.length) + " / 50 ", 1)
        ]),
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("button", {
            tabindex: "0",
            "aria-label": "Close folder modal",
            onKeydown: handleCloseKey,
            onClick: close,
            class: "buttons-button buttons-cancel"
          }, "Cancel ", 32),
          _createElementVNode("button", {
            tabindex: "0",
            "aria-label": "Create",
            onClick: handleCreateFolder,
            onKeydown: handleKeyDown,
            class: "buttons-button buttons-create",
            disabled: !newFolder.value.trim() || loading.value
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Creating... ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Create ")
                ], 64))
          ], 40, _hoisted_7)
        ])
      ])), [
        [_directive_focustrap]
      ])
    ]),
    _: 1
  }, 8, ["visible", "aria-expanded"]))
}
}

})